import React from 'react';
import { TextField, withStyles } from '@material-ui/core';
import { asField } from 'informed';

const CustonDateInput = withStyles({
  root: {
    width: "100%",
    height: "31px",
    "& .MuiInput-underline:after": {
      height: "31px"
    },
    "& .MuiOutlinedInput-root": {
      height: "31px",
      borderRadius: "10px",
      border: "1px solid #DED8D8",
      fontFamily: "Public Sans",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: 400,
      background: "#F7F7F7",
      color: "#383838",
      textAlign: "center",
      "& fieldset": {
        border: "none",
        height: "31px"
      },
      "&:hover fieldset": {
        height: "31px"
      },
      "&.Mui-focused fieldset": {
        height: "31px"
      }
    }
  }
})(TextField);


export default asField(({
  fieldState,
  fieldApi,
  field,
  onChange,
  label,
  helpBlock,
  col,
  ...props
}) => (
  <React.Fragment>
    <div className={`${col} form-group`} >
      <label
        style={{
          color: '#333333',
          fontSize: '14px',
          fontWeight: '600',
          font: 'Quicksand',
          marginBottom: '3px'
        }}
        htmlFor={field}
      >
        {label}
      </label>

      <CustonDateInput
        variant="outlined"
        type="datetime-local"
        id={field}
        value={fieldState.value || ''}
        onChange={e => {
          fieldApi.setValue(e.target.value);
          fieldApi.setError(null);
          if (onChange) {
            onChange(e.target.value);
          }
        }}
        {...props}
      />
    </div>
    {helpBlock && <small className="form-text text-muted">{helpBlock}</small>}
    {fieldState.error && <small className={fieldState.error ? 'text-danger' : null}>{fieldState.error}</small>}
  </React.Fragment>
));
